export default {
    terms: {
        controllers: 'Buildings',
    },
};
